import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

import QuestStatusSelectOption from './QuestStatusSelectOption'
import QuestStatusSelectValue from './QuestStatusSelectValue'

export class QuestStatusSelect extends Component {
  constructor (props) {
    super(props)
    this.handleSelectChangeBound = this.handleSelectChange.bind(this)
  }

  render () {
    const { dropdownValues } = this.props
    let dropdownValuesMessages = {
      allQuests: {
        text: 'All quests',
        value: []
      },
      draft: {
        text: 'Draft',
        value: [1]
      },
      inPublicationReview: {
        text: 'In Publication Review',
        value: [0, 4]
      },
      reviewReturned: {
        text: 'Review Returned',
        value: [2]
      },
      published: {
        text: 'Published',
        value: [5]
      }
    }

    // if dropdownValues props included, need to filter out the ones not specified
    if (dropdownValues) {
      Object.keys(dropdownValuesMessages).forEach(dvm => {
        if (!dropdownValues.includes(dvm)) {
          delete dropdownValuesMessages[dvm]
        }
      })
    }

    const statusValues = Object.values(dropdownValuesMessages).map(status => {
      return {
        value: status.value,
        label: status.text,
        className: `${status.text.toLowerCase().replace(/ /g, '-')}`
      }
    })

    return (
      <Select
        ref={this.props.statusFilterRef}
        options={statusValues}
        value={this.getValue(statusValues)}
        onChange={this.handleSelectChangeBound}
        deleteRemoves={false}
        clearable={false}
        searchable={false}
        optionComponent={QuestStatusSelectOption}
        valueComponent={QuestStatusSelectValue}
      />
    )
  }

  getValue (statusValues) {
    const { draftFilterSelected, statusFilters, allStatusChecked } = this.props

    if (allStatusChecked) {
      return statusValues[0]
    } else if (draftFilterSelected) {
      return statusValues[1]
    } else {
      return statusValues.find(status => {
        return JSON.stringify(status.value) === JSON.stringify(statusFilters)
      })
    }
  }

  handleSelectChange (value) {
    this.props.setStatusFilter(value)
  }
}

QuestStatusSelect.propTypes = {
  setStatusFilter: PropTypes.func.isRequired,
  draftFilterSelected: PropTypes.bool.isRequired,
  statusFilters: PropTypes.array.isRequired,
  allStatusChecked: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  dropdownValues: PropTypes.array,
  statusFilterRef: PropTypes.object
}

export default QuestStatusSelect



// WEBPACK FOOTER //
// ./src/components/mini/QuestStatusSelect.js